import {
  HttpMethod,
  HttpRepository,
} from "../../core/repository/http_repository";
import { Report } from "./report_model";

export class ReportHttpRepository extends HttpRepository {
  get = (kind: "exams" | "students", id: string, page: number) =>
    this._jsonRequest<Report>(
      HttpMethod.GET,
      `/reports/${kind}/${encodeURIComponent(id)}?page=${page}`,
    );
}
